



























































































































































































































































































































































































































import { Component, Mixins, Watch } from 'vue-property-decorator';
import { getModule } from 'vuex-module-decorators';
import AccountModule from '@/store/modules/Account';
import GeneralModule from '@/store/modules/General';
import BalanceModule from '@/store/modules/Balance';
import AuthModule from '@/store/modules/Auth';
import CreateAccountData from '@/data/CreateAccount';
import ErrorHandleMixin from '@/mixins/ErrorHandle.vue';
import CurrencyModule from '@/store/modules/Currency';
import GetBalanceModule from '@/store/modules/Profile';
import MarketingModule from '@/store/modules/Marketing';
import jwt_decode from 'jwt-decode';

@Component
export default class AddAgentView extends Mixins(ErrorHandleMixin) {
  AccountInstance = getModule(AccountModule, this.$store);

  GeneralInstance = getModule(GeneralModule, this.$store);

  AuthInstance = getModule(AuthModule, this.$store);

  BalanceInstance = getModule(BalanceModule, this.$store);

  CurrencyModule = getModule(CurrencyModule, this.$store);

  GetBalanceInstance = getModule(GetBalanceModule, this.$store);

  MarketingInstance = getModule(MarketingModule, this.$store)

  mainKey = 0;

  api = 'API';

  ipWhitelist = '';

  UserData: any = { ...CreateAccountData.initialUserData() };

  isCheckedPrefix = false;

  currencyData: any[] = [];

  currencyRate: any = {};

  async created() {
    const resSelf = await this.MarketingInstance.Fetch();
    this.UserData.isFeature = await resSelf[0].isFeature;
    this.initial();
  }

  async initial() {
    this.UserData.role = 'AGENT';
    const Response = await this.CurrencyModule.fetchCurrencyRate();
    this.currencyRate = Response.rateCurrency;
    if (this.AuthInstance.user.role === 'COMPANY') {
      this.UserData.type = 'CREDITLINE';
      this.api = 'B2B';
      this.currencyData = Response.currency;
    } else {
      const expToken: any = jwt_decode(this.AuthInstance.token);
      this.currencyData = [String(expToken.currency)];
    }
    const { status, data } = await this.AccountInstance.GenerateUser({
      role: this.UserData.role,
    });
    if (status.code) {
      this.checkError(status);
    } else {
      this.UserData.username = data.username;
    }
  }

  toggleAPI({ target: { innerText } }) {
    this.api = innerText;
    if (innerText === 'None API' || this.AuthInstance.user.role === 'COMPANY') {
      this.UserData.type = 'CREDITLINE';
    } else {
      this.UserData.type = 'SEAMLESS';
    }
  }

  toggleBetType({ target: { innerText } }) {
    this.UserData.type = innerText.trim().toUpperCase();
  }

  async onSubmit() {
    if (this.ipWhitelist) {
      this.UserData.ipWhitelist = await this.ipWhitelist.split(',').map((v) => v.trim());
    }
    if (this.UserData.url.slice(-1) !== '/') {
      this.UserData.url = `${this.UserData.url}/`;
    }
    this.GeneralInstance.toggleLoading(true);
    const {
      status: {
        code, message,
      },
      data,
    } = await this.AccountInstance.CreateAccount(this.UserData);
    if (code === 0) {
      await this.BalanceInstance.Refill({
        userId: data._id,
        type: 'TRANSFER',
        amount: this.UserData.balance,
        username: data.username,
        currency: this.UserData.currency,
        source: this.UserData.source,
      });
      this.mainKey += 1;
      this.UserData = { ...CreateAccountData.initialUserData() };
      this.initial();
      this.ipWhitelist = '';
    }
    this.GetBalanceInstance.GetBalance();
    this.GeneralInstance.toggleLoading(false);
    this.GeneralInstance.ShowAlert({
      isAlert: true,
      alertMsg: message,
      alertColor: code === 0 ? 'success' : 'danger',
    });
  }

  async checkPrefix() {
    if (!this.UserData.source) {
      this.GeneralInstance.ShowAlert({
        isAlert: true,
        alertMsg: 'Prefix Required',
        alertColor: 'danger',
      });
    } else {
      this.GeneralInstance.toggleLoading(true);
      const { code, message } = await this.AccountInstance.CheckPrefix({
        prefix: this.UserData.source,
      });
      this.GeneralInstance.toggleLoading(false);
      this.isCheckedPrefix = code === 0;
      this.GeneralInstance.ShowAlert({
        isAlert: true,
        alertMsg: message,
        alertColor: code === 0 ? 'success' : 'danger',
      });
    }
  }

  @Watch('UserData.source')
  changePrefix() {
    this.isCheckedPrefix = false;
  }
}
